import React, {Component} from 'react';

import {IntlProvider} from 'react-intl';
import Reboot from '@material-ui/core/CssBaseline';
import {MuiThemeProvider} from '@material-ui/core/styles';
import { Provider } from 'react-redux';
import WaitForLogin from './containers/WaitForLogin';
import AccountApp from './containers/AccountApp';

import theme from './theme';
import store from './store';

import translations from './constants/translations';
import { withCurrentUserId } from './containers/withUser';

const MyAccountApp = withCurrentUserId(AccountApp);

export default class App extends Component {
  render() {
    return (
        <IntlProvider 
          locale="en" 
          messages={translations.en}
        >
          <Provider store={store}>
            <MuiThemeProvider theme={theme}>
              <Reboot />
              <WaitForLogin>
                <MyAccountApp />
              </WaitForLogin>
            </MuiThemeProvider>
          </Provider>
        </IntlProvider>
      
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js